<div class="content-height">
    <div class="row h-100">
        <div class="col-12 col-lg-7 image-section" [class.image-section-partner]="isPartnerLink">
            <div class="container h-100">
                <div class="d-flex flex-column justify-content-between align-items-center py-4 h-100">
                    <div>
                        <ng-container *ngIf="isPartnerLink; else FAlogo">
                            <img *ngIf="partnerLogo" class="img img-fluid" width="120" [src]="partnerLogo"
                                alt="Education Loan">
                        </ng-container>
                        <ng-template #FAlogo>
                            <img class="img img-fluid" width="120"  *ngIf="!isPartnerLink"
                                src='https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674449525190Group%20%281%29.png'
                                alt="Education Loan">
                        </ng-template>
                    </div>
                    <div class="px-3 px-lg-10 mt-n9 mt-lg-n6">
                        <img class="img img-fluid fadeIn"
                            src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1681985667687young%20people%20working%20at%20the%20desk.png"
                            alt="Thank you">
                    </div>

                    <div>
                        <p class="mb-0 text-center" [class.text-light]="!isPartnerLink"
                            [class.text-primary-dark]="isPartnerLink">Your review matters a lot for us. Your shared experience will help us to make our process more easy, convenient, and  understandable</p>
                    </div>
                    <div *ngIf="isPartnerLink" class="d-flex justify-content-center align-items-center">
                        <p class="mb-0 me-2">Powered by</p>
                        <img width="120px" class="img img-fluid"
                            src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674329951680Group.png"
                            alt="ForeignAdmits">
                    </div>
                </div>

            </div>
        </div>
        <div class="col-12 col-lg-5">
            <div class="container h-100">

                <div class="d-flex flex-column justify-content-center align-items-center px-4 h-100">
                    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1681985810856robot%20smile.png" alt="Thank you" class="img img-fluid">
                    <h3 class="text-primary-dark text-center mb-4">
                        Thank you for your feedback.
                    </h3>
                    <p class="text-primary-dark text-center mb-4">
                        Our team will get in touch with you.
                    </p>
                    <div class="container">
                        <a (click)="clearDetails()"
                            class="btn btn-primary gradient px-6 py-2 w-100">Back To Home</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>